module.exports = __webpack_public_path__ + "img/19.5354182f.jpg";